import * as React from "react";
import { Dialog, Button } from "@app/components";
import {
  ButtonContainer,
  ConfirmationContent,
  ConfirmationContentWrapper,
  DialogFooter,
} from "./header.component";

type Props = {
  onClose: (e: any) => void;
  logoutUser: (e: any) => void;
  logoutText: string;
};

export default function Pill({ onClose, logoutUser, logoutText }: Props) {
  return (
    <Dialog title="Confirm Logout" onClose={onClose}>
      <ConfirmationContentWrapper>
        <ConfirmationContent className="m-0">Are you sure you want to logout?</ConfirmationContent>
      </ConfirmationContentWrapper>
      <DialogFooter className="with-no-border alt-padding alt-height">
        <Button variant="text" customClass="w-unset mr-1" onClick={onClose}>
          Cancel
        </Button>
        <ButtonContainer className="w-unset" disabled={logoutText === "Logging Out..."}>
          <Button variant="newsecondary" customClass="w-unset" onClick={logoutUser}>
            {logoutText}
          </Button>
        </ButtonContainer>
      </DialogFooter>
    </Dialog>
  );
}
